function get(data, propertyKey) {
    if (typeof data !== "object") {
        return undefined
    }
    return data[propertyKey]
}

export default {
    get(data, propertyChainStr, defaultValue?: any) {
        const propertyKeys = propertyChainStr.split(".")
        let currentValue = data
        for (const i in propertyKeys) {
            const propertyKey = propertyKeys[i]
            currentValue = get(currentValue, propertyKey)
            if (currentValue === undefined) {
                return defaultValue
            }
        }
        return currentValue
    }
}
